import React from "react";
import "../style/footer.scss";
import LinkButton from "../components/LinkButton";

export default function Footer() {
  return (
    <footer className="footer wrapper">
      <div className="p-30">
        <div>
          <h3>Linkovi</h3>
          <ul>
            <li>
              <a href="/">Početna</a>
            </li>
            <li>
              <a href="/o-meni">O Meni</a>
            </li>
            <li>
              <a href="/galerija-radova">Galerija</a>
            </li>
            <li>
              <a href="/puder-obrve">Puder obrve</a>
            </li>
            <li>
              <a href="/kontakt">Kontakt</a>
            </li>
            <li>
              <a href="/najcesce-postavljena-pitanja">FAQ</a>
            </li>
          </ul>
        </div>
        <div>
          <h3>Kontakt</h3>
          <ul>
            <li>
              <a href="mailto:info@helibrows.rs">info@helibrows.rs</a>
            </li>
          </ul>
        </div>
        <div>
          <h3>Društvene mreže</h3>
          <ul>
            <li>
              <a href="https://www.instagram.com/heli_brows/" target="_blank" rel="noreferrer">Instagram</a>
            </li>
          <li>
          <a href="https://www.tiktok.com/@heli_brows" target="_blank" rel="noreferrer">TikTok</a>
          </li>
          </ul>
        </div>
      </div>

      <div className="copyright p-30">
        <div>
          <p>
            ©2025 Heli Brows | Sva prava su zadržana
            <br />
            by{" "}
            <a
              style={{ fontWeight: 600, color: "#000" }}
              href="https://www.brandone.rs"
              target="_blank" rel="noreferrer"
            >
              Brand One
            </a>
          </p>
        </div>

        <LinkButton link="/kontakt" buttonText="Zakazi termin" />
      </div>
    </footer>
  );
}
